var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.007,
    height: 49,
    viewBox: "0 0 48.007 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment",
    transform: "translate(0.188 -0.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit-card_1_",
    "data-name": "credit-card (1)",
    transform: "translate(4.757 -61.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6822",
    "data-name": "Group 6822",
    transform: "translate(-97.057 7.31)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1216",
    "data-name": "Ellipse 1216",
    cx: 24,
    cy: 24.5,
    rx: 24,
    ry: 24.5,
    transform: "translate(92.111 54.316)",
    fill: "#c27add"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15095",
    "data-name": "Path 15095",
    d: "M168.166,85.186c0-.967-7.4-13.5-10.4-16.136l-8.914,7.031-17.163,26.568,6.149,6.313a24.167,24.167,0,0,0,30.329-23.776Z",
    transform: "translate(-28.048 -6.527)",
    fill: "#a95bc6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "giftbox",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 97.973, 63.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6828",
    "data-name": "Group 6828",
    transform: "translate(0.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15098",
    "data-name": "Path 15098",
    d: "M27.636,4.219S23.416,0,18.516,0a3.6,3.6,0,0,0-3.947,3.811c0,1.906,1.157,3.811,3.267,3.811h9.8Z",
    transform: "translate(-14.569)",
    fill: "#fbe77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15099",
    "data-name": "Path 15099",
    d: "M27.636,4.219S23.416,0,18.516,0a3.6,3.6,0,0,0-3.947,3.811c0,1.906,1.157,3.811,3.267,3.811h9.8Z",
    transform: "translate(-14.569)",
    fill: "#fbe77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15100",
    "data-name": "Path 15100",
    d: "M297.626,4.219S301.846,0,306.746,0a3.6,3.6,0,0,1,3.947,3.811c0,1.906-1.157,3.811-3.267,3.811h-9.8Z",
    transform: "translate(-279.115)",
    fill: "#fbe77b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15101",
    "data-name": "Path 15101",
    d: "M32.176,122H1.308A1.308,1.308,0,0,1,0,120.69v-2.829a1.308,1.308,0,0,1,1.308-1.308H32.176a1.308,1.308,0,0,1,1.308,1.308v2.829A1.308,1.308,0,0,1,32.176,122Z",
    transform: "translate(0 -108.931)",
    fill: "#fb636f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15102",
    "data-name": "Path 15102",
    d: "M484.943,116.552V122h.422a1.348,1.348,0,0,0,1.347-1.347V117.9a1.348,1.348,0,0,0-1.347-1.347h-.422Z",
    transform: "translate(-453.229 -108.93)",
    fill: "#fa4954"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15103",
    "data-name": "Path 15103",
    d: "M193.561,116.553h8.167V122h-8.167Z",
    transform: "translate(-180.902 -108.931)",
    fill: "#fbe77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15104",
    "data-name": "Path 15104",
    d: "M55.694,220.222H28.365a1.308,1.308,0,0,1-1.308-1.308V199.8H57v19.109A1.308,1.308,0,0,1,55.694,220.222Z",
    transform: "translate(-25.288 -186.738)",
    fill: "#fb636f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15105",
    "data-name": "Path 15105",
    d: "M27.057,199.8H57v1.633H27.057Z",
    transform: "translate(-25.288 -186.738)",
    fill: "#fa4954"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15106",
    "data-name": "Path 15106",
    d: "M214.374,199.8h5.445v20.417h-5.445Z",
    transform: "translate(-200.354 -186.738)",
    fill: "#fbe77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15107",
    "data-name": "Path 15107",
    d: "M214.374,199.8h5.445v1.633h-5.445Z",
    transform: "translate(-200.354 -186.738)",
    fill: "#fcc52e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15108",
    "data-name": "Path 15108",
    d: "M299.531,51.489a.681.681,0,0,1-.629-.42c.176-.064.365-.128.561-.183a.505.505,0,1,0-.274-.973c-.116.033-.229.068-.339.1V48.393a14.612,14.612,0,0,0-1.225,1.055v3.4h9.8a3,3,0,0,0,2.547-1.361Z",
    transform: "translate(-278.161 -45.228)",
    fill: "#fcc52e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15109",
    "data-name": "Path 15109",
    d: "M36.691,48.393v1.625c-.11-.036-.223-.071-.339-.1a.505.505,0,1,0-.274.973c.2.055.386.118.561.183a.681.681,0,0,1-.628.419H25.569a3,3,0,0,0,2.547,1.361h9.8v-3.4A14.609,14.609,0,0,0,36.691,48.393Z",
    transform: "translate(-23.897 -45.228)",
    fill: "#fcc52e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15110",
    "data-name": "Path 15110",
    d: "M219.819,54.307h-5.445v-3.44a.916.916,0,0,1,.916-.916H218.9a.916.916,0,0,1,.916.916Z",
    transform: "translate(-200.354 -46.684)",
    fill: "#fbe77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15111",
    "data-name": "Path 15111",
    d: "M214.374,95.74h5.445V97.1h-5.445Z",
    transform: "translate(-200.354 -89.479)",
    fill: "#fcc52e"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGift);
export default __webpack_public_path__ + "static/media/icon-gift.510e9f88.svg";
export { ForwardRef as ReactComponent };